/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const XLineTop = [
  ["path", { d: "M18 4H6" }],
  ["path", { d: "M18 8 6 20" }],
  ["path", { d: "m6 8 12 12" }]
];

export { XLineTop as default };
//# sourceMappingURL=x-line-top.js.map
